import moment from "moment-jalaali";
import "moment-timezone";

export const APP_TIME_ZONE = "Europe/Amsterdam";

const DEFAULT_FORMAT = "YYYY/M/D HH:mm:ss";

export const toGregorianFormat = (format = DEFAULT_FORMAT) =>
  format
    .replace(/jYYYY/g, "YYYY")
    .replace(/jYY/g, "YY")
    .replace(/jMM/g, "MM")
    .replace(/jM/g, "M")
    .replace(/jDD/g, "DD")
    .replace(/jD/g, "D");

const toAmsterdamMoment = (time) => {
  if (time?._isAMomentObject) {
    return time.clone().tz(APP_TIME_ZONE);
  }
  if (time instanceof Date) {
    return moment(time).tz(APP_TIME_ZONE);
  }
  return moment.utc(time).tz(APP_TIME_ZONE);
};

export function utcToLocalTime(time, format = DEFAULT_FORMAT) {
  const value = time?._d instanceof Date ? time._d : time;
  if (!value || !isValidMomentDate(value)) {
    return null;
  }

  return toAmsterdamMoment(value).format(toGregorianFormat(format));
}

export function utcToTime(time, format = DEFAULT_FORMAT) {
  return utcToLocalTime(time, format);
}

export function utcToTimeIran(time, format = "YYYY/M/D HH:mm") {
  return utcToLocalTime(time, format);
}

export function zonedInputToIso(input, format = "YYYY-MM-DD HH:mm") {
  if (!input) return null;
  const wallClock = moment.utc(input, toGregorianFormat(format), true);
  if (!wallClock.isValid()) return null;
  const offset = wallClock.clone().tz(APP_TIME_ZONE).utcOffset();
  return wallClock.clone().subtract(offset, "minutes").toISOString();
}

export function formatCalendarDate(time, format = "YYYY/MM/DD") {
  if (!time) return null;
  const date =
    time._d instanceof Date ? time._d : time instanceof Date ? time : new Date(time);
  if (Number.isNaN(date.getTime())) return null;
  return moment(date).format(toGregorianFormat(format));
}

export function isValidDate(dateString) {
  const date = new Date(dateString);
  return date instanceof Date && !isNaN(date.getTime());
}

export function isValidMomentDate(dateString) {
  if (!dateString) return false
  return !moment(dateString).isSame("0001-01-01 00:00:00");
}
export const meterToHumanReadableDistance = (dis) => {
  const KM = Math.floor(dis / 1000);
  const M = Math.floor(dis - KM * 1000);

  if (Math.floor(KM) === 0 && Math.floor(M) === 0) {
    return `-`;
  }
  if (KM === 0) {
    return `${M}m`;
  }

  return `${KM}Km ${M}m`;
};

export function utcToHumanReadableTime(time) {
  const houres = Math.floor(time / 3600);
  const minutes = Math.floor(time / 60) - houres * 60;
  const seconds = time - minutes * 60 - houres * 3600;

  if (
      Math.floor(minutes) === 0 &&
      Math.floor(houres) === 0 &&
      Math.floor(seconds) === 0
  ) {
    return `-`;
  }
  if (Math.floor(minutes) === 0 && Math.floor(houres) === 0) {
    return `${Math.floor(seconds)}s`;
  }
  if (houres === 0) {
    return `${Math.floor(minutes)}m ${Math.floor(seconds)}s`;
  }
  return `${Math.floor(houres)}h ${Math.floor(minutes)}m ${Math.floor(
      seconds
  )}s`;
}

export function utcToHumanReadableClockTime(time) {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);

  if (hours === 0 && minutes === 0 && seconds === 0) return `-`;

  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export const keysToLowerCase = (obj) => {
  var keys = Object.keys(obj);
  var n = keys.length;
  var newobj = {};
  while (n--) {
    var key = keys[n];
    if (key === "FileData") {
      var childs = Object.keys(obj[key]);
      var count = childs.length;
      var newObject = {};
      while (count--) {
        var child = childs[count];
        newObject[child[0].toLowerCase() + child.slice(1)] = obj[key][child];
      }
      newobj[key[0].toLowerCase() + key.slice(1)] = newObject;
    } else {
      newobj[key[0].toLowerCase() + key.slice(1)] = obj[key];
    }
  }
  return newobj;
};

export const ConvertToHMSWithTag = (time) => {
  const splitedTime = time.split(":");
  if (splitedTime[0] !== "00")
    return `${splitedTime[0]}h, ${splitedTime[1]}m, ${splitedTime[2]}s`;
  if (splitedTime[1] !== "00") return `${splitedTime[1]}m, ${splitedTime[2]}s`;
  return `${splitedTime[2]}s`;
};

export const FaToEnDigits = (s) =>
    s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
